import React from 'react';
import './styles.css';
import iconXCircle from '../../../assets/icons/icon-x-circle.svg';

const Tooltip = ({ children, isTop, visible, onClose }: any) => (
  <div className="tooltip">
    {children}
    {/* <span className={`tooltiptext ${isTop ? 'tooltipTop' : 'tooltipBottom'}`}>
      {text}
    </span> */}
    <span
      className={`tooltiptext ${isTop ? 'tooltipTop' : 'tooltipBottom'} ${
        visible ? 'tooltipVisible' : 'tooltipHidden'
      }`}
    >
      <div className="toolFlex">
        <div>
          <p className="tooltipTitle">Estructura del código de ambiente</p>
          <p className="tooltipContent">
            Ej: Si tu aula es &quot;B0119&quot;, significa que:
          </p>
          <ul>
            <li> &quot;B&quot; es el Pabellón</li>
            <li> &quot;01&quot; es el Piso</li>
            <li> &quot;19&quot; es el N° de ambiente</li>
          </ul>
        </div>
        <button type="button" className="tooltipClose" onClick={onClose}>
          <img src={iconXCircle} alt="" />
        </button>
      </div>
    </span>
  </div>
);

export default Tooltip;
